import * as Api from "./ApiRequest";
import * as path from "./ApiList";

 
export const addRealEstate = function(...params){
    return Api.postRequest(path.AGENTS_ADD_URL,params[0]);
}

// export const fetchRealAgentsList = function(...params){
//     return Api.getRequest(path.AGENTS_LIST_URL,params[0]);
// }

export const updateRealEstate = function(...params){
    const URL = `${path.AGENTS_UPDATE_URL}/${params[0].id}`;
    return Api.postRequest(URL, params[0]);
}

export const deleteRealAgents = function (...params) {
    //console.log(params[0].data.sp_id,"this is params...");
    const URL = `${path.AGENTS_DELETE_URL}/${params[0].data.sp_id}`;
    return Api.getRequest(URL, params[0]);
    //return Api.getRequest(path.AGENTS_DELETE_URL,params[0]);
   };

   export const deleteThridParty = function (...params) {
    //console.log(params[0].data.sp_id,"this is params...");
    const URL = `${path.THIRD_PARTY_DELETE_URL}/${params[0].data.sp_id}`;
    return Api.getRequest(URL, params[0]);
    //return Api.getRequest(path.AGENTS_DELETE_URL,params[0]);
   };
//deleteRequest
export const fetchByidRealAgentsList = function(...params){
    const URL = `${path.AGENTS_UPDATE_GET_URL}/${params[0].data}`;
    return Api.getRequest(URL, params[0]);
}
export const fetchRealAgentsList1 = function (...params) {
   
    let URL = "";
    const { page, size, searchText } = params[0];
    URL = `${path.AGENTS_LIST_URL}`;
    if (searchText) {
      URL = `${path.AGENTS_LIST_URL}${searchText}`;
    }else if(page) {
        URL = `${path.AGENTS_LIST_URL}&page=${page}`;
    }
    else{
        URL = `${path.AGENTS_LIST_URL}`
    }
    return Api.getRequest(URL);
  };




export const fetchThirdPartyList1 = function (...params) {
    let URL = "";
    const { page, size, searchText } = params[0];
    URL = `${path.THIRD_LIST_URL}`;
    if (searchText) {
      URL = `${path.THIRD_LIST_URL}${searchText}`;
    }else if(page) {
        URL = `${path.THIRD_LIST_URL}&page=${page}`;
    }
    else{
        URL = `${path.THIRD_LIST_URL}`
    }
    return Api.getRequest(URL);
  };

///Third Party started  

export const addThirdParty = function(...params){
    return Api.postRequest(path.THIRD_ADD_URL,params[0]);
}

export const fetchThirdPartyList = function(...params){
    return Api.getRequest(path.THIRD_LIST_URL,params[0]);
}

export const fetchRealAgentsOption = function(...params){
    return Api.getRequest(path.AGENTS_DROP_DAWN,params[0]);
}

export const updateThirdParty = function(...params){
    const URL = `${path.THIRD_PARTY_UPDATE_URL}/${params[0].id}`;
    return Api.postRequest(URL, params[0]);
}

export const fetchThirdPartyById = function(...params){
    const URL = `${path.THIRD_PARTY_UPDATE_GET_URL}/${params[0].data}`;
    return Api.getRequest(URL, params[0]);
}

/// Internal CRM

export const addInternal = function(...params){
    return Api.postRequest(path.INTERNAL_ADD_URL,params[0]);
}

export const fetchInternalList = function(...params){
    return Api.getRequest(path.INTERNAL_LIST_URL,params[0]);
}

export const updateInternal = function(...params){
    const URL = `${path.INTERNAL_UPDATE_URL}/${params[0].id}`;
    return Api.postRequest(URL, params[0]);
}
export const internalApiTest = function(...params){
    const URL = `${path.INTERNAL_API_TEST_URL}`;
    let datapost = {
        "id":(params[0].data.id) ? params[0].data.id: "",
        "authtokendpoint": params[0].data.authtokendpoint,
        "clientid": params[0].data.clientid,
        "clientsecretkey": params[0].data.clientsecretkey
    }
    return Api.postRequestApiTest(URL,datapost);
}
export const thirdpartyCredentailsTest = function(...params){
    const URL = `${path.THIRD_PARTY_API_TEST_URL}`;
    let datapost = {
        "id":(params[0].data.id) ? params[0].data.id: "",
        "crmId":parseInt(params[0].data.crmname),
        "apiendpoints": params[0].data.apiendpoints,
        "apikeys": params[0].data.apikeys,
        "apitokens": params[0].data.apitokens,
        "accountid": params[0].data.accountid
    }
    return Api.postRequestApiTest(URL,datapost);
}

export const thirdpartyAPITest = function(...params){
    const URL = `${path.REX_API_TEST_URL}`;
    let datapost = {
        "id":parseInt(params[0].id)
    }
    return Api.postRequestApiTest(URL,datapost);
}

export const fetchInternalId = function(...params){
    const URL = `${path.INTERNAL_UPDATE_GET_URL}/${params[0].data}`;
    return Api.getRequest(URL, params[0]);
}


export const fetchInternalList1 = function (...params) {
    let URL = "";
    const { page, size, searchText } = params[0];
    URL = `${path.INTERNAL_LIST_URL}`;
    if (searchText) {
      URL = `${path.INTERNAL_LIST_URL}${searchText}`;
    }else if(page) {
        URL = `${path.INTERNAL_LIST_URL}&page=${page}`;
    }
    else{
        URL = `${path.INTERNAL_LIST_URL}`
    }
    return Api.getRequest(URL);
  };

  export const deleteInternal = function (...params) {
    //console.log(params[0].data.sp_id,"this is params...");
    const URL = `${path.INTERNAL_DELETE_URL}/${params[0].data.sp_id}`;
    return Api.getRequest(URL, params[0]);
    //return Api.getRequest(path.AGENTS_DELETE_URL,params[0]);
   };

//CRM drop Dawn....

export const fetchCrmExternalOption = function(...params){
    return Api.getRequest(path.CRM_DROP_DAWN_EXTERNAL_URL,params[0]);
}

export const fetchCrmInternalOption = function(...params){
    return Api.getRequest(path.CRM_DROP_DAWN_INTERNAL_URL,params[0]);
}

// export const fetchHistoryLog = function(...params){
//     return Api.getRequest(path.HISTORY_LOG_API,params[0]);
// }


export const fetchHistoryLog = function (...params) {
 
    let URL = "";
    const { page, searchText ,connectorid,startdate,enddate} = params[0];
    URL = `${path.HISTORY_LOG_API}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    if (searchText) {
      URL = `${path.HISTORY_LOG_API}${searchText}&page=${page}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    }else if(page) {
        URL = `${path.HISTORY_LOG_API}&page=${page}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    }
    else if(page && searchText) {
        URL = `${path.HISTORY_LOG_API}${searchText}&page=${page}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    }
    else{
        URL = `${path.HISTORY_LOG_API}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`
    }
    return Api.getRequest(URL);
  };

export const fetchHistoryDetailsLog = function(...params){
    const URL = `${path.HISTORY_LOG_DETAILS_API}${params[0].data}`;
    return Api.getRequest(URL, params[0]);
}
export const fetchDetailsCon = function(...params){
    const URL = `${path.HISTORY_LOG_DETAILS_API_CONSUMER}${params[0].data}`;
    return Api.getRequest(URL, params[0]);
}



export const fetchHistoryDetailsLogConsumer = function (...params) {
 
    let URL = "";
    const { page, searchText ,connectorid,startdate,enddate} = params[0];
    URL = `${path.HISTORY_LOG_DETAILS_CONSUMER_API}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    if (searchText) {
      URL = `${path.HISTORY_LOG_DETAILS_CONSUMER_API}${searchText}&page=${page}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    }else if(page) {
        URL = `${path.HISTORY_LOG_DETAILS_CONSUMER_API}&page=${page}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    }
    else if(page && searchText) {
        URL = `${path.HISTORY_LOG_DETAILS_CONSUMER_API}${searchText}&page=${page}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`;
    }
    else{
        URL = `${path.HISTORY_LOG_DETAILS_CONSUMER_API}&connectorid=${connectorid}&startdate=${startdate}&enddate=${enddate}`
    }
    return Api.getRequest(URL);
  };

export const fetchConnectorDropDawn = function(...params){
    const URL = `${path.CONNECTOR_DROP_DAWN_URL+"&size=1000"}`;
    return Api.getRequest(URL, params[0]);
}

export const fetchConsumerDropDawn = function(...params){
    const URL = `${path.CONSUMER_DROP_DAWN_URL+"&size=1000"}`;
    return Api.getRequest(URL, params[0]);
}

export const addDirectConsumer = function(...params){
    return Api.postRequest(path.ADD_DIRECT_CONSUMER_DETAIL_URL,params[0]);
}
export const addThirdPartyWebHook = function(...params){
    return Api.postRequest(path.THIRD_ADD_URL,params[0]);
}
